import { Link } from "react-router-dom";
import logo from "../assets/burgersson-logo.png";

const EventsCTA = () => {
  return (
    <section
      className="relative py-24 px-6 md:px-16 overflow-hidden"
      style={{ backgroundColor: "#A8ADA9" }}
    >
      {/* Watermark logo background */}
      <div
        className="absolute inset-0 flex items-center justify-center pointer-events-none"
        aria-hidden="true"
      >
        <img
          src={logo}
          alt=""
          className="w-full h-full object-cover opacity-10"
          style={{ filter: "grayscale(100%)" }}
        />
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto relative z-10">
        <h2
          className="font-heading text-2xl md:text-3xl tracking-wide text-white uppercase mb-6"
          style={{ lineHeight: "1.15" }}
        >
          Event / Företag / Stora Sällskap
        </h2>
        <p className="font-body text-sm text-white/70 leading-[1.8] mb-10 max-w-2xl">
          Planerar du en fest, kickoff eller middag för ett större sällskap? Vi
          erbjuder skräddarsydda menyer och exklusiva arrangemang för grupper
          från 15 personer och uppåt. Kontakta oss för att boka.
        </p>
        <Link
          to="/events"
          className="inline-block px-8 py-3 rounded-full border border-white/40 text-xs font-body font-medium uppercase tracking-widest text-white hover:bg-white hover:text-black transition-all duration-300"
        >
          Läs Mer
        </Link>
      </div>
    </section>
  );
};

export default EventsCTA;
